<template>
    <div class=" m-0 p-0 w-full" :class="isUserDataAvailable ? 'mb-25' : ''"
        v-if="enabled">
        <div class=" row w-full justify-content-center">
            <div class="col "
                :class="isUserDataAvailable ? 'col' : 'col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6'">
                <div class="border-0 rounded-0 bg-white">
                    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
                        <SpinnerLoading v-if="loading === true" class="h-auto" :small="true" />
                        <span v-else-if="adverseEventConfig && adverseEventConfig.enabled" >{{ descriptionParts.before }}<a
                                :href="'mailto:' + adverseEventConfig.email">{{ adverseEventConfig.email }}</a>{{
                                    descriptionParts.after }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import API from '@/services/api/api.service';
import { AdverseEventConfig } from '@/utils/models/adverse_event.model';
import config from '@/utils/const/config';
import stateStore from '@/utils/store';
import { Modal } from 'bootstrap';
import { defineComponent } from 'vue';
import { Role } from '@/utils/models/user.model';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";


export default defineComponent({
    name: "AdverseEventMessage",
    data() {
        return {
            loading: false as boolean,
            modal: null as Modal | null,
            modal_message: '' as string,
            userData: null as any,
            adverseEventConfig: null as AdverseEventConfig | null,
        }
    },
    components: {
        SpinnerLoading,
    },
    async mounted() {
        this.getUserDataFromStore();
        await this.getadverseEventMessageData();
    },
    methods: {
        async getadverseEventMessageData() {
            if (!this.enabled) return;
            try {
                this.adverseEventConfig = null;
                this.loading = true;
                let res;
                if (this.isUserDataAvailable && this.userData.info.zone_id) {
                    res = await API.getAdverseEventConfig(this.userData.info.zone_id);
                } else {
                    res = await API.getAdverseEventConfigPrelogin();
                }
                this.adverseEventConfig = res.data.data;
            } catch (error) {
                console.error('ADVERSE_EVENT_CONFIG_ERROR', error);
            } finally {
                this.loading = false;
            }
        },
        getUserDataFromStore() {
            const userData = stateStore.user;
            if (userData) {
                this.userData = userData;
            }
        },
    },
    computed: {
        isUserDataAvailable(): boolean {
            return this.userData !== null && this.userData.info && this.userData.info.length !== 0;
        },
        descriptionParts(): { before: string; after: string } {
            if (!this.adverseEventConfig) return { before: '', after: '' };
            const parts = this.adverseEventConfig.dashboard_description.split('[EMAILADDRESS]');
            return { before: parts[0] ?? '', after: parts[1] ?? '' };
        },
        enabled(): boolean {
            return (config.feature.report_adverse_event ?? false) && (stateStore.user?.info?.role?.type ? stateStore.user?.info?.role?.type === Role.hcp : true);
        },
    },
    watch: {
        '$i18n.locale': function () {
            this.getadverseEventMessageData();
        },
    },
    
})
</script>